import {
  FETCH_TOP_KEYWORDS_OVERVIEW_IN_PROGRESS,
  FETCH_TOP_KEYWORDS_OVERVIEW_SUCCESSFUL,
  FETCH_TOP_KEYWORDS_OVERVIEW_FAILED,
  FETCH_TOP_KEYWORDS_IN_PROGRESS,
  FETCH_TOP_KEYWORDS_SUCCESSFUL,
  FETCH_TOP_KEYWORDS_FAILED,
  FETCH_TOP_KEYWORDS_FOR_DASHBOARD_IN_PROGRESS,
  FETCH_TOP_KEYWORDS_FOR_DASHBOARD_FINISHED
} from "./types";

import { LOGOUT } from "../iam/types";

const initialState = {
  network_activity: [],
  default_order_by: "tr",
  default_order_dir: "desc",
  overview: {},
  by_website_guid: {}
};

const networkActivityMessages = {
  overview: "fetch_overview_",
  top_keywords: "fetch_top_keywords_",
  top_keywords_for_dashboard: "fetch_top_keywords_for_dashboard_"
};

const topKeywordsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TOP_KEYWORDS_OVERVIEW_IN_PROGRESS:
      return {
        ...state,
        network_activity: [
          ...state.network_activity,
          `${networkActivityMessages["overview"]}${action.guid}${action.seo_db}`
        ]
      };
    case FETCH_TOP_KEYWORDS_OVERVIEW_SUCCESSFUL:
      return {
        ...state,
        network_activity: state.network_activity.filter(
          item => item !== `${networkActivityMessages["overview"]}${action.guid}${action.seo_db}`
        ),
        overview: {
          ...state.overview,
          [action.guid]: {
            ...state.overview[action.guid],
            [action.seo_db]: action.overview
          }
        }
      };
    case FETCH_TOP_KEYWORDS_OVERVIEW_FAILED:
      return {
        ...state,
        network_activity: state.network_activity.filter(
          item => item !== `${networkActivityMessages["overview"]}${action.guid}${action.seo_db}`
        )
      };
    case FETCH_TOP_KEYWORDS_IN_PROGRESS: {
      const h_key = `${action.seo_db}_${action.order_by}_${action.order_dir}`;
      return {
        ...state,
        network_activity: [
          ...state.network_activity,
          `${networkActivityMessages["top_keywords"]}${action.guid}${h_key}`
        ]
      };
    }
    case FETCH_TOP_KEYWORDS_SUCCESSFUL: {
      const h_key = `${action.seo_db}_${action.order_by}_${action.order_dir}`;
      return {
        ...state,
        network_activity: state.network_activity.filter(
          item => item !== `${networkActivityMessages["top_keywords"]}${action.guid}${h_key}`
        ),
        by_website_guid: {
          ...state.by_website_guid,
          [action.guid]: {
            ...state.by_website_guid[action.guid],
            [h_key]:
              state.by_website_guid[action.guid] &&
              state.by_website_guid[action.guid][h_key] &&
              state.by_website_guid[action.guid][h_key]["keywords"]
                ? {
                    ...state.by_website_guid[action.guid][h_key],
                    keywords: [...state.by_website_guid[action.guid][h_key]["keywords"], ...action.keywords],
                    has_more: action.has_more
                  }
                : {
                    keywords: action.keywords,
                    has_more: action.has_more
                  }
          }
        }
      };
    }
    case FETCH_TOP_KEYWORDS_FAILED: {
      const h_key = `${action.seo_db}_${action.order_by}_${action.order_dir}`;
      return {
        ...state,
        network_activity: state.network_activity.filter(
          item => item !== `${networkActivityMessages["top_keywords"]}${action.guid}${h_key}`
        )
      };
    }
    case FETCH_TOP_KEYWORDS_FOR_DASHBOARD_IN_PROGRESS: {
      return {
        ...state,
        network_activity: [
          ...state.network_activity,
          `${networkActivityMessages["top_keywords_for_dashboard"]}${action.domain}${action.seoDb}`
        ]
      };
    }
    case FETCH_TOP_KEYWORDS_FOR_DASHBOARD_FINISHED: {
      return {
        ...state,
        network_activity: state.network_activity.filter(
          item => item !== `${networkActivityMessages["top_keywords_for_dashboard"]}${action.domain}${action.seoDb}`
        )
      };
    }
    case LOGOUT:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};

export default topKeywordsReducer;
